/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetScopeCreateDto } from '../../models/core-timesheet-scope-create-dto';
import { CoreTimesheetScopeResponseDto } from '../../models/core-timesheet-scope-response-dto';

export interface TimesheetScopesControllerCreate$Params {

/**
 * Tenant identifier
 */
  tenant: string;
      body: CoreTimesheetScopeCreateDto
}

export function timesheetScopesControllerCreate(http: HttpClient, rootUrl: string, params: TimesheetScopesControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetScopesControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>;
    })
  );
}

timesheetScopesControllerCreate.PATH = '/o2-core/timesheet-scopes/{tenant}';
